import type { VueCookies } from 'vue-cookies';

import { useAppStore } from '@/stores/app';

export function useAppCookies() {
  const appStore = useAppStore();
  // @ts-expect-error global $cookies injected by vue-cookies plugin
  const cookies = $cookies as VueCookies;

  const getCookies = (key: string): any => {
    return cookies.get(key);
  };

  const setCookies = (key: string, value: any): VueCookies => {
    return cookies.set(key, value, undefined, undefined, appStore.cookieDomain);
  };

  const removeCookies = (key: string, path?: string): boolean => {
    return cookies.remove(key, path, appStore.cookieDomain as string);
  };

  return { cookies, getCookies, setCookies, removeCookies };
}
